

























import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PermissionMixin from '@/mixins/PermissionMixin';

@Component({})
export default class SelectionDropdown extends mixins(PermissionMixin) {
  @Prop() public status!: string;

  @Prop() public loading!: boolean;

  private accountStatus = 'inactive';

  private backgroundColor = 'secondary';

  private items = [
    {
      text: 'Active',
      value: 'active',
    },
    {
      text: 'Inactive',
      value: 'inactive',
    },
  ];

  public mounted() {
    this.accountStatus = this.status;
  }

  @Watch('status')
  onChangeStatus(nextValue: string, prevValue: string) {
    if (this.accountStatus !== nextValue) {
      this.accountStatus = nextValue;
    }
  }

  public toggleSelected(status: any) {
    this.accountStatus = status;
    if (this.accountStatus === 'inactive') {
      this.backgroundColor = 'tertiary2';
    } else {
      this.backgroundColor = 'secondary';
    }
    this.$emit('on-update-status', this.accountStatus);
  }

  public getColor() {
    if (this.accountStatus === 'inactive') {
      return 'tertiary2';
    }
    return 'secondary';
  }
}
